import React from 'react';

/**
 * Mini annotated diagram of the Airbnb listing page showing the scroll order
 * (Map → Meet your host → Host details → Message host button). The
 * "Message host" pill is highlighted with a pulsing green ring + arrow so
 * hosts know exactly where to tap after the deep link opens their Airbnb app.
 */
export const MessageHostDiagram = ({ width = 230, dataTestId = 'message-host-diagram' }) => {
  const height = width * (260 / 230);
  return (
    <svg
      data-testid={dataTestId}
      width={width}
      height={height}
      viewBox="0 0 230 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Scroll under the map, past Host details, then tap Message host"
    >
      {/* Phone frame */}
      <rect x="6" y="4" width="148" height="252" rx="22" fill="#FFFFFF" stroke="#111" strokeWidth="2" />
      <rect x="48" y="10" width="60" height="6" rx="3" fill="#111" />

      {/* Map block */}
      <rect x="16" y="26" width="128" height="46" rx="8" fill="#E6F0E6" />
      <path d="M22 60 L48 42 L72 58 L98 38 L138 64" stroke="#9BBE9B" strokeWidth="2" fill="none" strokeLinecap="round" />
      <circle cx="98" cy="38" r="4" fill="#C83A4E" />
      <text x="22" y="48" fontFamily="'Inria Serif', serif" fontSize="8" fontWeight="700" fill="#0F6B19">Map</text>

      {/* Meet your host */}
      <text x="16" y="86" fontFamily="'Inria Serif', serif" fontSize="9" fontWeight="700" fill="#111">Meet your host</text>
      <circle cx="28" cy="104" r="10" fill="#D3FFE1" stroke="#0F6B19" strokeWidth="1.2" />
      <rect x="44" y="98" width="46" height="5" rx="2" fill="#333" />
      <rect x="44" y="106" width="36" height="4" rx="2" fill="#999" />

      {/* Host details */}
      <text x="16" y="132" fontFamily="'Inria Serif', serif" fontSize="9" fontWeight="700" fill="#111">Host details</text>
      <rect x="16" y="138" width="100" height="3.5" rx="1.5" fill="#CFCFCF" />
      <rect x="16" y="146" width="80" height="3.5" rx="1.5" fill="#CFCFCF" />
      <rect x="16" y="154" width="92" height="3.5" rx="1.5" fill="#CFCFCF" />

      {/* Pulsing ring around Message host */}
      <rect x="20" y="172" width="92" height="26" rx="13" fill="none" stroke="#04A628" strokeWidth="2.2">
        <animate attributeName="stroke-opacity" values="0.4;1;0.4" dur="1.6s" repeatCount="indefinite" />
      </rect>
      {/* Message host pill */}
      <rect x="24" y="176" width="84" height="18" rx="9" fill="#F2F2F2" />
      <text x="66" y="188" textAnchor="middle" fontFamily="'Inria Serif', serif" fontSize="9" fontWeight="700" fill="#111">Message host</text>

      {/* Arrow pointing at the pill from the right */}
      <path d="M210 184 C 188 184, 174 184, 140 184" stroke="#04A628" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <path d="M148 178 L138 184 L148 190" stroke="#04A628" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />

      {/* "Tap here" label */}
      <text x="216" y="180" textAnchor="end" fontFamily="'Inria Serif', serif" fontSize="11" fontWeight="700" fill="#04A628">Tap here</text>
      <text x="216" y="194" textAnchor="end" fontFamily="'Inria Serif', serif" fontSize="9" fill="#0F6B19">it’s easy to miss</text>

      {/* Scroll hint chevrons on the left edge of the phone */}
      <g opacity="0.55">
        <path d="M30 220 L36 226 L42 220" stroke="#999" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M30 232 L36 238 L42 232" stroke="#999" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <text x="80" y="232" fontFamily="'Inria Serif', serif" fontSize="9" fill="#666">scroll down</text>
    </svg>
  );
};

export default MessageHostDiagram;
